import React from 'react';

type Props = {
  title: string;
  buttonTitle: string;
  onClick: () => void;
};

export const BrowseHeadline: React.FC<Props> = ({ title, buttonTitle, onClick }) => {
  return (
    <div className='row pt-2 pb-2 pt-sm-3 pb-sm-3 align-items-center'>
      <h1 className='col headline headline--medium'>{title}</h1>
      <div className='col-auto d-block d-sm-none'>
        <button
          className='btn btn--border'
          style={{ marginTop: -4, minWidth: '90.69px' }}
          onClick={onClick}
        >
          {buttonTitle}
        </button>
      </div>
    </div>
  );
};
